


















import { Component, Prop, Mixins } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import { IAccount } from "@/models/accounts";
import { ICurrency } from "@/models/constants";
import { IPaymentDetail } from "@/models/paymentDetails";
import { QUERY_PARAMS } from "@/data/constants";
import { DataModules } from "@/store/modules/data";
import PaymentProvider from "@/components/app/global/payments/selectPaymentMethod/provider.vue";
import { mapState } from "vuex";
import {
  StoredCardData,
  PaymentMethodType
} from "@/models/selectPaymentMethod";
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      paymentDetail(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: DataModules.CLIENTS_PAYMENT_DETAILS,
          scope: this.dataScope
        });
      }
    })
  }
})
export default class TopUpWalletAutoPayModal extends Mixins(PaymentProvider) {
  @Prop({ default: undefined })
  public amount!: number;

  @Prop({ default: undefined })
  public clientId!: IClient["id"];

  @Prop({ default: undefined })
  public currencyId!: ICurrency["id"];

  @Prop({ default: undefined })
  public accountId!: IAccount["id"];

  @Prop({ default: undefined })
  public preselectedStoredPaymentMethodId!: IPaymentDetail["id"];

  // Data
  public isProcessing = true;
  public paymentDetail!: IPaymentDetail;

  public async created() {
    try {
      await Promise.all([this.waitMinimum(), this.initPayment()]);
    } finally {
      this.isProcessing = false;
    }
  }

  public waitMinimum() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(true);
      }, 2 * 1000);
    });
  }

  public async initPayment() {
    await this.getPaymentDetail();
    await this.topUp();
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binSingle", {
      storeModule: DataModules.CLIENTS_PAYMENT_DETAILS,
      scope: this.dataScope,
      vm: this
    });
  }

  // Getters
  public get totalAmountToPay() {
    return this.$_.toNumber(this.amount);
  }

  public get dataScope() {
    return `$client_${this.clientId}_topup`;
  }

  public get additionalPaymentData() {
    const returnUrl = window.location.href.split("?")[0];
    const returnUrlEncodedSuccess = encodeURIComponent(
      `${returnUrl}?${QUERY_PARAMS.PAYMENT_SUCCESS}=true`
    );
    const returnUrlEncodedFail = encodeURIComponent(
      `${returnUrl}?${QUERY_PARAMS.PAYMENT_SUCCESS}=false`
    );

    return {
      client_id: this.clientId,
      account_id: this.accountId,
      currency_id: this.currencyId,
      return_url: `?${QUERY_PARAMS.SUCCESS}=${returnUrlEncodedSuccess}&${QUERY_PARAMS.FAILED}=${returnUrlEncodedFail}`,
      cancel_url: returnUrl
    };
  }

  // Methods

  public getPaymentDetail() {
    return this.$store.dispatch(
      `data/${DataModules.CLIENTS_PAYMENT_DETAILS}/get`,
      {
        clientId: this.clientId,
        scope: this.dataScope,
        paymentDetailId: this.preselectedStoredPaymentMethodId
      }
    );
  }

  // Overwrite
  public async topUp() {
    if (!this.preselectedStoredPaymentMethodId) {
      this.isProcessing = false;
      this.$emit("close");
      return;
    }

    try {
      await this.$store.dispatch(
        `data/${DataModules.CLIENTS_PAYMENT_DETAILS}/get`,
        {
          clientId: this.clientId,
          paymentDetailId: this.preselectedStoredPaymentMethodId
        }
      );

      this.paymentMethod = {
        amount: this.amount || 0,
        type: PaymentMethodType.STORED_CARD,
        data: {
          payment_details_id: this.preselectedStoredPaymentMethodId
        } as StoredCardData
      };

      await this.preparePaymentData(this.clientId);
      // Execute payment
      await this.executePayment();
      // Emit 'success'
      this.$emit("success");
      this.$emit("close");
    } catch (error) {
      this.$emit("error");
      this.$emit("close");
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }
}
